enum Sizing {
  INLINE = 'inline',
  FIXED = 'fixed',
  FULL_WIDTH = 'full-width',
}

export default Sizing;
